import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import PlatformOverview from "@/pages/home/components/PlatformOverview";
import AccessSteps from "@/pages/home/components/AccessSteps";
import EntryTypes from "@/pages/home/components/EntryTypes";
import LatestAddress from "@/pages/home/components/LatestAddress";
import Authenticity from "@/pages/home/components/Authenticity";
import AddressChange from "@/pages/home/components/AddressChange";
import SafetyTips from "@/pages/home/components/SafetyTips";
import FaqSection from "@/pages/home/components/FaqSection";
import FinalCta from "@/pages/home/components/FinalCta";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <PlatformOverview />
        <AccessSteps />
        <EntryTypes />
        <LatestAddress />
        <Authenticity />
        <AddressChange />
        <SafetyTips />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}